import axios from 'axios'

const instance = axios.create({
  // baseURL: 'http://localhost:5000/api/', // for dev env.
   baseURL: 'https://mantraserp.com/api/', // for live production
    headers:{"Content-Type":"application/json"},
    withCredentials:true
  });
export default instance